import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export interface DeleteCustomClassTypeEndpointRequest {
  customClassTypeId: number
  planPeriodId: string
}

const deleteCustomClassTypeEndpoint = (values: DeleteCustomClassTypeEndpointRequest): Promise<any> => {
  return adminHttpClient.delete('/Benefit/DeleteCustomClassType', {
    data: values,
  })
}

export default deleteCustomClassTypeEndpoint
